import axios from "axios";
import { c2bAuthKey } from "../constants/url-constants";

const api = axios.create({
    baseURL: process.env.C24_BFF_SERVICE_URL,
    headers: {
        "Content-Type": "application/json",
        "x_basic_a": `Basic ${c2bAuthKey()}`
    }
});

export const C24BffService = {
    getMsiteAppointmentByToken: (token, tokenType = "") => {
        return api.get(`/api/v1/lead/appointment/token/${token}`, {
            params: tokenType ? { "token_type": tokenType } : {},
            headers: {
                "x-client-type": "MWEB"
            }
        });
    },

    getAddOnStripData: ({ params, secureToken }) => {
        return api.get(`/api/v1/screens/seller/add-on-cards`, {
            params,
            headers: {
                Authorization: `Bearer ${secureToken}`
            }
        });
    },

    getCancellationBottomSheetData: ({ params, secureToken }) => {
        return api.get(`/api/v1/screens/seller/appointment/cancellation`, {
            params,
            headers: {
                Authorization: `Bearer ${secureToken}`
            }
        });
    },

    getPackageOrderDetails: ({ params, secureToken }) => {
        return api.get(`/api/v1/screens/seller/order-details`, {
            params,
            headers: {
                Authorization: `Bearer ${secureToken}`
            }
        });
    },

    getOrderDetails: ({ params, orderNumber, secureToken }) => {
        return api.get(`/api/v1/screens/seller/orders/${orderNumber}`, {
            params,
            headers: {
                Authorization: `Bearer ${secureToken}`
            }
        });
    },
    getOrderList: ({authToken}) => {
        return api.get("/api/v1/screens/seller/orders", {
            headers: {
                "Authorization": `Bearer ${authToken}`
            }
        });
    },
    getAnimationData: ({leadToken, authToken}) => {
        return api.get(`api/v1/screens/seller/active-order/${leadToken}`, {
            headers: {
                "Authorization": `Bearer ${authToken}`
            }
        });
    },

    getShowNewPage: ({ leadToken, secureToken }) => {
        return api.get("/api/v1/thankyou/show-new-page", {
            params: { leadToken },
            headers: {
                ...(secureToken && { "Authorization": `Bearer ${secureToken}` })
            }
        }).catch(() => ({ data: { showNewThankYouPage: false } }));
    },

    getSellerHelpChatTree: ({ params, secureToken }) => {
        return api.get("/api/v1/screens/seller/help", {
            params,
            headers: {
                ...(secureToken && { "Authorization": `Bearer ${secureToken}` })
            }
        });
    },

    checkV3Enabled: (leadToken, secureToken) => {
        return api.get(`/api/v1/screens/seller/package/v3-enabled`, {
            params: {
                leadToken
            },
            headers: {
                "Authorization": `Bearer ${secureToken}`
            }
        });
    },
    getRepeatUserData: ({ token, secureToken }) => {
        return api.get(`/api/v1/users/repeat/${token}`, {
            headers: {
                Authorization: `Bearer ${secureToken}`
            }
        });
    },

    getOrderSummary: ({authToken, orderNumber}) => {
        return api.get(`/api/order/order-summary/${orderNumber}`, {
            headers: {
                "Authorization": `Bearer ${authToken}`
            }
        });
    },

    getInvoiceLink: ({authToken, orderNumber}) => {
        return api.get(`/api/order/invoice/${orderNumber}`, {
            headers: {
                "Authorization": `Bearer ${authToken}`
            }
        });
    },

    createChallanCart: ({authToken, regNumber, challanIdentifiers}) => {
        return api.post(`/api/v1/challan-cart`,
            { regNumber, challanIdentifiers },
            {
                headers: {
                    "Authorization": `Bearer ${authToken}`,
                    "X_tenant_id": "CARS24_INDIA",
                    "origin_source": "web"
                }
            }
        );
    }
};
